.controlButton svg {
  width: 24px;
  height: 24px;
  margin-top: 2px;
}
